import { useQuery } from '@apollo/client';
import AGENCY_GRAPHQL_QUERY from '../components/agency-list/agencies-graphql-query';
var useAgenciesInLocalities = _ref => {
  var _result$data;
  var localities = _ref.localities;
  var result = useQuery(AGENCY_GRAPHQL_QUERY, {
    skip: !localities,
    variables: {
      localities: localities === null || localities === void 0 ? void 0 : localities.map(locality => ({
        id: locality.id,
        type: locality.type
      })),
      agencyLimit: 3,
      sort: {
        type: 'SELL',
        goldFirst: false,
        allLocations: false
      }
    }
  });
  return result === null || result === void 0 ? void 0 : (_result$data = result.data) === null || _result$data === void 0 ? void 0 : _result$data.agencySearch;
};
export default useAgenciesInLocalities;